import { useEffect, useState } from 'react'
import { Monitor, Moon, Sun } from 'lucide-react'
import { setTheme, storedTheme, type Theme } from '@/lib/theme'
import {
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu'

const ICON = { system: Monitor, light: Sun, dark: Moon }
const TEXT = { system: 'Follow system', light: 'Light', dark: 'Dark' }

/**
 * The theme picker, as a submenu of the user menu.
 *
 * It used to be a cycling button in the sidebar footer; it moved into the menu
 * on request, and the move changed the right shape. A cycling item inside a
 * dropdown is the worst of both — the menu closes on every press, so reaching
 * "dark" from "system" is two open-click round trips. A radio submenu shows all
 * three states and reaches any of them in one.
 */
export function ThemeSubMenu() {
  const [theme, set] = useState<Theme>(() => storedTheme())
  useEffect(() => setTheme(theme), [theme])
  const Icon = ICON[theme]
  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <Icon className="text-muted-foreground" />
        Theme
      </DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent>
          <DropdownMenuRadioGroup value={theme} onValueChange={(v) => set(v as Theme)}>
            <DropdownMenuRadioItem value="light">
              <Sun /> {TEXT.light}
            </DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="dark">
              <Moon /> {TEXT.dark}
            </DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="system">
              <Monitor /> {TEXT.system}
            </DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  )
}
